import { createBaseThemeVariation } from './base';
export const NuffieldHealthTheme = createBaseThemeVariation({
    name: 'nuffieldhealth',
    brandColor: 'hsla(120, 100%, 32%, 1)',
});
